var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"hide-delimiters":"","interval":"10000"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }